import EventIntro from './EventIntro';
export default EventIntro;
